import config from '../config'
import CoreServices from './coreServices'
import { REALTIME } from '../constants/services'
import axios from 'axios'
class RealtimeServices extends CoreServices {
  async getRandom(previousUser) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/calls/random?previous=${previousUser || ''}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getRecents(queries) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/calls/recents`, {
        params: queries,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getOnlines(queries) {
    try {
      let response = await axios.get(`${this.apiEnpointV1}/calls/recent-onlines`, {
        params: queries,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async startCall(receiverId, isSearch = false) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/start`, { receiverId: receiverId, isSearch: isSearch },{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  // async receivedCall(receiverId) {
  //   try {
  //     let response = await axios.post(`${this.apiEnpointV1}/calls/received`, { receiverId: receiverId }, {
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json',
          
  //       },
  //     })
  //     let data = await response.data.data

  //     return data
  //   } catch (error) {
  //     return { error }
  //   }
  // }

  async cancelCall(callId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/${callId}/cancel`, {},{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async declineCall(receiverId, callId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/decline`, { receiverId: receiverId, callId: callId },{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async acceptCall(receiverId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/accept`, { receiverId: receiverId },{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async offerCall(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/offer`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async answerCall(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/answer`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async resolution(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/resolution`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async candidateCall(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/candidate`, { receiverId: args.receiverId, candidate: args.candidate },{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async pingCall(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/ping`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      return response.data.data
    } catch (error) {
      return { error }
    }
  }

  async review(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/${args.callId}/review`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      return { }
    } catch (error) {
      return { error }
    }
  }

  async endCall(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/end`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async captureScrenshot(args) {
    axios.post(`${this.apiEnpointV1}/calls/screenshots`, args, {
      headers: {
      },
    }).catch(() => {})
  }

  async uploadVideo(args) {
    axios.post(`${this.apiEnpointV1}/calls/video`, args, {
      headers: {
      },
    }).catch(() => {})
    
  }

  async detectFace(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/detect-face`, args, {
      })
      return response.data.data

    } catch (error) {
      return { error }
    }
  }

  async detectNudity(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/detect-nudity`, args, {
      })
      return response.data.data

    } catch (error) {
      return { error }
    }
  }

  async checkIsInQueue() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/check-queue`, {}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          
        },
      })
      return response.data.data
    } catch (error) {
      return { error }
    }
  }

  async report(args) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/webrtc/report`, args, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return response
    } catch (error) {
      return { error }
    }
  }

  /**
   * Short-lived LiveKit access token for a call's SFU room. The API secret
   * lives on the backend; this only ever returns { url, room, token }.
   */
  async getLiveKitToken(callId) {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/webrtc/livekit-token`, { callId: callId }, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      return response.data.data
    } catch (error) {
      return { error }
    }
  }

  async startBestGirls() {
    try {
      let response = await axios.post(`${this.apiEnpointV1}/calls/start-best-girls`, { },{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      })
      let data = await response.data.data

      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new RealtimeServices(REALTIME.BASE)
